var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    ref: "inputRef",
    staticClass: "pt-0",
    attrs: {
      disabled: _vm.disabled,
      items: _vm.coItems,
      solo: "",
      multiple: _vm.multiple,
      loading: _vm.dtIsLoading,
      "search-input": _vm.dtSearch,
      clearable: false,
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      label: _vm.label,
      placeholder: _vm.placeholder,
      "return-object": _vm.returnObject,
      rules: _vm.rules,
      "hide-selected": "",
      "hide-details": _vm.hideDetails,
      "no-data-text": _vm.noDataText
        ? _vm.noDataText
        : _vm.$t("LBL_SELECTOR_NO_DATA")
    },
    on: {
      "update:searchInput": function($event) {
        _vm.dtSearch = $event
      },
      change: _vm.handleChange
    },
    scopedSlots: _vm._u([
      {
        key: "selection",
        fn: function(data) {
          return _c(
            "v-chip",
            {
              attrs: {
                close: "",
                color: _vm.disabled ? "grey" : "secondary",
                "text-color": "whitePure"
              },
              on: {
                input: function($event) {
                  _vm.handleRemove(data.item.id)
                }
              }
            },
            [
              _c("v-icon", { staticClass: "mr-2" }, [_vm._v(_vm._s(_vm.icon))]),
              _vm._v(" "),
              _c("span", { style: { icon: "margin-left: 7px;" } }, [
                _vm._v(_vm._s(data.item[_vm.itemText]))
              ])
            ],
            1
          )
        }
      }
    ]),
    model: {
      value: _vm.vModel,
      callback: function($$v) {
        _vm.vModel = $$v
      },
      expression: "vModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7de0f4b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7de0f4b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/autocomplete/template.html
// module id = null
// module chunks = 